import React from 'react';
import { useEmailRefreshStore } from '@/lib/store';
// Note: useEmailProgress import removed as it's not currently used

export const EmailProgress: React.FC = () => {
  const { progress, error, infoMessage, isRefreshing } = useEmailRefreshStore();
  
  // Don't show anything if not refreshing and no info message
  if (!isRefreshing && !infoMessage && !error) {
    return null;
  }

  // Determine progress bar color based on state
  const barColor = error 
    ? 'bg-red-500' 
    : progress?.stage === 'error' 
      ? 'bg-red-500' 
      : infoMessage
        ? (infoMessage.includes('No new') || infoMessage.includes('no new') ? 'bg-amber-500' : 'bg-green-500')
        : 'bg-blue-500';

  // Format stage and step for display
  const formattedStage = progress?.stage
    ? progress.stage.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
    : infoMessage
      ? 'Complete'
      : 'Initializing';

  const formattedStep = progress?.step
    ? progress.step.replace(/_/g, ' ')
    : infoMessage 
      ? ''
      : 'Starting...';

  // Get the display message
  const displayMessage = error 
    ? error 
    : infoMessage 
      ? infoMessage
      : progress?.detail 
        ? progress.detail
        : isRefreshing && progress?.stage === 'email_processing'
          ? 'Processing emails... This may take several minutes. Please keep this page open.'
          : 'Processing...';

  // Calculate progress percentage
  const progressPercent = progress?.percent ?? (infoMessage ? 100 : isRefreshing ? 10 : 0);

  return (
    <div className="w-full space-y-3">
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div 
          className={`h-2 rounded-full transition-all duration-300 ${barColor}`}
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      <div className="space-y-2">
        <div className="flex justify-between items-start">
          <div className="flex-1 pr-2">
            <span className="text-sm font-medium text-gray-900">
              {formattedStage}
              {formattedStep && ` - ${formattedStep}`}
            </span>
          </div>
          <div className="flex-shrink-0">
            <span className="text-sm font-medium text-gray-600">{progressPercent.toFixed(1)}%</span>
          </div>
        </div>
        {displayMessage && (
          <div className={`text-sm leading-relaxed ${
            error 
              ? 'text-red-600' 
              : infoMessage?.includes('No new') || infoMessage?.includes('no new')
                ? 'text-amber-600'
                : infoMessage
                  ? 'text-green-600'
                  : 'text-gray-600'
          }`}>
            {displayMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailProgress;